import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const advance = (filteredInfos, activeName) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    const isCancel = activeName === 'REFUND_CANCELLED'
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 100
        },
        {
            title: '垫付款状态',
            dataIndex: 'advancePaymentStatus',
            key: 'advancePaymentStatus',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'advancePaymentStatus'
            },
            filteredValue: filteredInfo.advancePaymentStatus || [],
        },
        {
            title: '付款单位',
            dataIndex: 'invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.invoiceTitle || [],
        },
        {
            title: '收款单位',
            dataIndex: 'receivingUnit',
            key: 'receivingUnit',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.receivingUnit || [],
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            roles: ['PAID', 'PENDING_REFUND', 'REFUNDED', 'REFUND_CANCELLED', 'ALL'],
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '合同金额',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            roles: ['PAID', 'PENDING_REFUND', 'REFUNDED', 'REFUND_CANCELLED', 'ALL']
        },
        {
            title: '垫付款金额',
            dataIndex: 'paymentAmount',
            key: 'paymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.paymentAmount || [],
        },
        {
            title: '垫付时间',
            dataIndex: 'paymentDate',
            key: 'paymentDate'
        },
        {
            title: '销售',
            dataIndex: 'sale.name',
            key: 'saleName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['PAID', 'PENDING_REFUND', 'REFUNDED', 'REFUND_CANCELLED', 'ALL'],
            filteredValue: filteredInfo.saleName || [],
        },
        {
            title: isCancel ? '取消退款人' : '退款人',
            dataIndex:  'refundPerson',
            key: 'refundPerson',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['REFUNDED', 'REFUND_CANCELLED', 'ALL'],
            filteredValue: filteredInfo[ 'refundPerson'] || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: isCancel ? '取消退款时间' : '退款时间',
            dataIndex:  'refundDate',
            key:  'refundDate',
            roles: ['REFUNDED', 'REFUND_CANCELLED', 'ALL'],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: isCancel ? '取消退款原因' : '退款备注',
            dataIndex: 'refundRemark',
            key: 'refundRemark',
            roles: ['REFUNDED', 'REFUND_CANCELLED', 'ALL'],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ].filter((item) => {
        return !item.roles || item.roles.includes(activeName)
    })
}
